// src/global/utils/getScreenType.js

const getDeviceType = (width) => {
    if (width >= 1024) return "DESKTOP";
    if (width >= 768) return "TABLET";
    return "MOBILE";
};

export function trackScreenSize(callback) {
    const handleResize = () => {
        const { innerWidth: width } = window;
        const deviceType = getDeviceType(width);
        callback({ width, height: window.innerHeight, deviceType });
    };

    // Ejecutar al cargar la página
    handleResize();

    // Escuchar cambios de tamaño
    window.addEventListener("resize", handleResize);

    // Retornar una función para eliminar el listener
    return () => {
        window.removeEventListener("resize", handleResize);
    };
}
